import { render, staticRenderFns } from "./PeriodsFilter.vue?vue&type=template&id=cdbc287a&scoped=true&"
import script from "./PeriodsFilter.vue?vue&type=script&lang=js&"
export * from "./PeriodsFilter.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsFilter.vue?vue&type=style&index=0&id=cdbc287a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbc287a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
